import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { StandardErrorFallback } from './StandardErrorFallback';
import { EmergencyFallbackErrorText } from '../../utils/owner-portal/errorHandling';

function Fallback(error: any) {
  return (
    <StandardErrorFallback
      reportToSentry
      errorInfo={error}
      customErrorMessage={EmergencyFallbackErrorText}
    />
  );
}

export function PageErrorGuard({ children }: PropsWithChildren) {
  return <ErrorBoundary fallbackRender={Fallback}>{children}</ErrorBoundary>;
}
